/*
 * ih-lp-product-checkout-mode.js
 *
 * Handles the direct-to-checkout mode for buy buttons rendered by
 * snippets/product-buy-buttons.liquid when checkout_mode === 'direct_to_checkout'.
 *
 * Click flow:
 *   1. User clicks the buy button (which carries data-checkout-mode="direct_to_checkout").
 *   2. We preventDefault on the form submit and AJAX-add to cart via cart/add.js
 *      using the theme's HELPER_UTIL.fetchData wrapper.
 *   3. On success, set window.location.href = '/checkout'.
 *   4. On error, dispatch the theme's standard error toast.
 *   5. Fallback: if the page is still visible 2s after a successful add (i.e. the
 *      redirect was silently blocked or CSP-blocked), show a "ready to checkout"
 *      toast so the shopper isn't left with a silently-added item.
 *
 * Compatibility:
 *   - Preserves existing cart contents (unlike /cart/<variant>:<qty> permalinks).
 *   - Works with selling-plan / subscription products (unlike permalinks).
 *   - Falls through to default form submit if HELPER_UTIL is not yet loaded.
 *
 * Loaded by sections/ih-lp-product.liquid via <script defer>. Uses event
 * delegation on document so re-rendered sections (e.g. customizer block reorder)
 * stay wired up without re-binding.
 */

(function () {
  if (window.ihLpProductCheckoutMode) {
    return; // guard against double-registration
  }
  window.ihLpProductCheckoutMode = true;

  function handleClick(event) {
    var button = event.target.closest('button[data-checkout-mode="direct_to_checkout"]');
    if (!button) return;
    var form = button.closest('form');
    if (!form) return;

    // If the theme helpers aren't loaded yet, let the default form submit happen.
    // The shopper will land in the cart drawer instead of /checkout, which is
    // better UX than a silent no-op.
    if (typeof HELPER_UTIL === 'undefined' || !HELPER_UTIL.fetchData) return;

    event.preventDefault();
    button.classList.add('loadingState');
    button.disabled = true;

    var formData = new FormData(form);
    // Include cart-drawer sections so the cart can still update if the redirect
    // fails — the toast fallback below will give the shopper a manual way out.
    if (HELPER_UTIL.sectionRenderUtil) {
      formData.append('sections', HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString());
    }

    var redirected = false;
    var redirectFallbackTimer = null;

    HELPER_UTIL.fetchData({
      method: 'POST',
      url: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js',
      data: formData,
      config: {
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        }
      },
      onsuccess: function (data) {
        // Best path: navigate to checkout. Set redirected so the fallback knows.
        redirected = true;
        // Update the cart count bubble before navigating, so the back-button
        // returning user sees the correct count.
        if (typeof _EVENT_HELPER !== 'undefined' && data && data.sections) {
          HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerCartChange, document, { sections: data.sections });
        }
        var code = (button.getAttribute('data-discount-code') || '').trim();
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var checkoutPath = root.replace(/\/?$/, '/') + 'checkout';
        // Prefer ?discount= on /checkout — theme-dev proxies /discount/* as 401/502.
        if (code) {
          var codes = code.split(/[\s,]+/).filter(Boolean).map(encodeURIComponent).join(',');
          window.location.href = checkoutPath + '?discount=' + codes;
        } else {
          window.location.href = checkoutPath;
        }

        // Fallback: if window.location didn't navigate within 2s (rare —
        // CSP block, popup-blocker, mid-flight network hiccup), surface a
        // toast with a manual link so the shopper isn't stranded.
        redirectFallbackTimer = setTimeout(function () {
          if (document.visibilityState === 'visible' && typeof _EVENT_HELPER !== 'undefined') {
            HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerToastMessage, document, {
              toastType: 'common-errors',
              messageType: 'success',
              message: 'Added to cart — click to checkout.'
            });
          }
        }, 2000);
      },
      onerror: function (error) {
        if (error && error.json) {
          error.json().then(function (errorObj) {
            if (typeof _EVENT_HELPER !== 'undefined') {
              HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerToastMessage, document, {
                toastType: 'common-errors',
                messageType: 'error',
                message: (errorObj && errorObj.description) || 'Could not start checkout. Please try again.'
              });
            }
          });
        }
      },
      defaultCb: function () {
        // Always restore the button so a retry is possible if redirect failed.
        // If redirect succeeded, this runs but the navigation is already underway.
        setTimeout(function () {
          button.classList.remove('loadingState');
          button.disabled = false;
          if (!redirected && redirectFallbackTimer) {
            clearTimeout(redirectFallbackTimer);
          }
        }, 600);
      }
    });
  }

  document.addEventListener('click', handleClick);
})();
